import SingleMatterSync from './SingleMatterSync';

export default SingleMatterSync;
